import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const GAPCard = ({ benefitCard }) => {
  const theme = useTheme();
  const { gapGreen, gapRed } = theme.custom.colors;

  const STATUS_COLOR = {
    success: gapGreen,
    error: gapRed,
    warning: theme.palette.warning.main,
  };

  if (!benefitCard) return null;

  const statusColor = STATUS_COLOR[benefitCard.status?.type] || theme.palette.text.secondary;

  return (
    <Box
      sx={{
        bgcolor: 'background.default',
        borderRadius: 2,
        p: 2,
        position: 'relative',
      }}
    >
      {/* Status badge */}
      {benefitCard.status?.label && (
        <Box sx={{ position: 'absolute', top: 0, right: 0, px: 1, py: 0.5 }}>
          <Typography variant="labelS" sx={{ color: statusColor }}>
            {benefitCard.status.label}
          </Typography>
        </Box>
      )}

      {/* Logo + title */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
        <Box
          component="img"
          src={benefitCard.logo_url}
          alt={benefitCard.name}
          sx={{ width: 48, height: 48, flexShrink: 0 }}
        />
        <Box>
          <Typography variant="h2">{benefitCard.name}</Typography>
          <Typography variant="body1" color="text.secondary">
            {benefitCard.description}
          </Typography>
        </Box>
      </Box>

      {/* Gross GAP row */}
      {benefitCard.gross && (
        <Box sx={{ pt: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="labelD" sx={{ flex: 1 }}>
              {benefitCard.gross.label}
            </Typography>
            <Typography variant="labelD" sx={{ flexShrink: 0 }}>
              {benefitCard.gross.value}
            </Typography>
          </Box>
          {benefitCard.gross.note && (
            <Typography variant="p3" color="text.secondary" sx={{ mt: 0.5 }}>
              {benefitCard.gross.note}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default GAPCard;
